import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
export function sanitizeObs (obs) {
  if (isEmpty(obs)) return ''
  if (obs === '[N/A]') {
    return 'Nada Consta'
  }
  if (obs.includes(']')) {
    // + 1 to remove ] itself
    return obs.substring(findIndex(obs, char => char === ']') + 1).trim()
  }
  return obs
}
